import { cva } from 'class-variance-authority'

export const tableFooterStyles = cva(
  `
    bg-neutral-100
    [&>tr]:border-none
    `
)

export const tableRowStyles = cva(
  `
    border-b border-neutral-200
   `
)

export const tableHeaderCellStyles = cva(
  `
    pt-[16px]
    pb-[16px]
    pl-[20px]
    pr-[20px]
    `,
  {
    variants: {
      sortable: {
        true: 'cursor-pointer',
        false: 'cursor-default',
      },
    },
    defaultVariants: {
      sortable: true,
    },
  }
)

export const tableHeaderCellIconStyles = cva(
  `
    h-[10px]
    ml-[8px]
    `,
  {
    variants: {
      hasTwoIcons: {
        true: '-mt-[4px]',
        false: '',
      },
    },
    defaultVariants: {
      hasTwoIcons: false,
    },
  }
)

export const tableHeaderCellDualIconWrapperStyles = cva(
  `
    pt-[4px]
    ml-[2px]
    flex
    flex-col
    `
)

export const tableHeaderCellWrapperStyles = cva(
  `
    flex
    items-center
    `
)

export const tableCellStyles = cva(
  `
    pt-[16px]
    pb-[16px]
    pl-[20px]
    pr-[20px]
    `
)
